/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UserInfo } from '../../models/user-info';

export interface GetAllUsersInfo$Params {
}

export function getAllUsersInfo(http: HttpClient, rootUrl: string, params?: GetAllUsersInfo$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<UserInfo>>> {
  const rb = new RequestBuilder(rootUrl, getAllUsersInfo.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<UserInfo>>;
    })
  );
}

getAllUsersInfo.PATH = '/admin/users/info';
